import React from 'react';
import { Container, Text } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { freeBetStore } from '../../../../store/freeBetStore';
import { applicationStore } from '../../../../store/applicationStore';

const FreeBetTitle = observer(() => {
  const { isFreeBetEnd } = freeBetStore;
  const {
    canvasTranslationKeys: { BONUS_ROUND_POPUP, CONGRATULATIONS_4 },
  } = applicationStore;

  return (
    <Container x={248} y={90} name='FreeBetTitleContainer'>
      <Text
        anchor={0.5}
        text={isFreeBetEnd ? BONUS_ROUND_POPUP : CONGRATULATIONS_4}
        style={{
          _fill: '#FFFFFF',
          _fontSize: 30,
          _fontWeight: 700,
          _wordWrap: true,
          _wordWrapWidth: 350,
          _align: 'center',
        }}
        resolution={2}
      />
    </Container>
  );
});

export default FreeBetTitle;
